module.exports = __webpack_public_path__ + "fonts/iconfont.7712aa52.eot";